import $ from 'jquery';
import { formatMoney } from '@shopify/theme-currency';


// VPGA Promo Scripts - Automatically add promo product if customer has Insider tag
if (theme.promo != undefined) {
	var applyPromo = false,
		promoProductVariantID = theme.promo.promoProductVariantID,
		hasPromoProduct = false;

	if (theme.promo.isSignedIn && theme.promo.isInsiderMember && theme.promo.cart.items.length >= 1 && !theme.promo.isPromoUsed) {
		applyPromo = true
	}

	$.map(theme.promo.cart.items, function(item) {

	    if (item.variant_id == promoProductVariantID) {
	    	hasPromoProduct = true;
	    }
	});

	if (!hasPromoProduct && applyPromo == true) {
		// console.log("Apply Promo Here");
		setTimeout(function(){
	        $.post('/cart/add.js', {
	          items: [
	            {
	              quantity: 1,
	              id: promoProductVariantID
	            }
	          ]
	        }).always(function(data){
	        	window.location.reload();
	        });
	    }, 1000);
	} else {

		if (hasPromoProduct == true && (!theme.promo.isSignedIn || !theme.promo.isInsiderMember || theme.promo.cart.items.length == 1 || theme.promo.isPromoUsed)) {
			// If there is promo product in cart, but customer doesn't login 
			// or isn't an Insider member 
			// or the only product in cart is promo product 
			// or this customer has purchased the promo product already
			// then remove the promo product from the cart
			$.post('/cart/change.js', {
			 	'id': promoProductVariantID,
			 	'quantity': 0
			}).done(function(data){
				window.location.reload();
			})
		}
	}
}

$('.cart__remove--ajax').on('click', function(e){
	e.preventDefault();
	var lineItemID = $(this).data('variant-id'),
		$this = $(this);
	$.post('/cart/change.js', {
	 	'id': lineItemID,
	 	'quantity': 0
	}).done(function(data){
		$this.closest('.cart__row').remove();
	 	$.getJSON('/cart.js', function(cart) {
			$('.cart__subtotal-price').html(formatMoney(cart.total_price));
		});
	})
})

